import * as React from 'react';
import { cn } from '../../utils';
import { Input, InputProps } from '../Input';

interface FormFieldProps extends Omit<InputProps, 'label'> {
  label: string;
  error?: string;
  helperText?: string;
  required?: boolean;
  children?: React.ReactNode;
}

function FormField({
  label,
  error,
  helperText,
  required,
  className,
  id,
  children,
  ...inputProps
}: FormFieldProps) {
  const inputId = id || label.toLowerCase().replace(/\s+/g, '-');

  return (
    <div className={cn('space-y-1.5', className)}>
      <label
        htmlFor={inputId}
        className="block text-sm font-medium text-foreground"
      >
        {label}
        {required && <span className="text-destructive ml-1">*</span>}
      </label>
      {children ? (
        children
      ) : (
        <Input
          id={inputId}
          aria-invalid={error ? 'true' : 'false'}
          aria-describedby={
            error ? `${inputId}-error` : helperText ? `${inputId}-helper` : undefined
          }
          {...inputProps}
        />
      )}
      {error && (
        <p id={`${inputId}-error`} className="text-sm text-destructive" role="alert">
          {error}
        </p>
      )}
      {helperText && !error && (
        <p id={`${inputId}-helper`} className="text-sm text-muted-foreground">
          {helperText}
        </p>
      )}
    </div>
  );
}

export { FormField };
